// extracted by mini-css-extract-plugin
export default {"scrollPagination":"_8MX7BIWYERmFwjzugL5w","common_bganimation":"ojm4LGXZry9xKDjAAvd9"};